import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="form-shell">
      <div className="card center-card">
        <h1>Page not found</h1>
        <p className="muted">The page you are looking for does not exist.</p>
        <Link to="/" className="btn btn-secondary">
          Go home
        </Link>
      </div>
    </div>
  );
}
